import SlideshowClient from './slideshow-client';

export async function generateStaticParams() {
  return [{ id: 'placeholder' }];
}

export default function SlideshowPage() {
  return <SlideshowClient />;
}
